import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import Field from "features/application/field/component";

import "features/application/sign-in/view.scss";

const SignInView = ({
  responseCodes,
  errorCodes,
  formReference,
  sendApiRequest,
}) => (
  <form
    className="application__container"
    noValidate
    ref={formReference}
    onSubmit={sendApiRequest}
  >
    <h1 className="application__headline">Start</h1>
    <div className="authentication__container">
      <Field
        label="E-mail address"
        name="email"
        type="email"
        maxLength={320}
        shouldValidate={true}
        rule="email"
        error="It doesn't look like a valid e-mail address."
      />
      <Field
        label="Password"
        name="password"
        type="password"
        maxLength={64}
        shouldValidate={true}
        rule="required"
        error="This field is required."
      />
      <Link className="authentication__link" to="/application/reset-password">
        Forgot password?
      </Link>
    </div>
    {responseCodes.confirmEmail ? (
      <p className="sign-in__information">
        Your email address has just been confirmed.
      </p>
    ) : responseCodes.createPassword ? (
      <p className="sign-in__information">
        Your info has been reset successfully! Now login with your new password.
      </p>
    ) : (
      responseCodes.changeEmail && (
        <p className="sign-in__information">
          Your e-mail address has been changed successfully!
        </p>
      )
    )}
    {errorCodes.createPassword &&
    errorCodes.createPassword.toString().startsWith("4") ? (
      <p className="sign-in__information">Your token has expired.</p>
    ) : errorCodes.signIn && errorCodes.signIn.toString().startsWith("4") ? (
      <p className="sign-in__information">Your credentials were incorrect.</p>
    ) : (
      (errorCodes.confirmEmail ||
        errorCodes.createPassword ||
        errorCodes.signIn ||
        errorCodes.changeEmail ||
        errorCodes.refreshToken ||
        errorCodes.settings ||
        errorCodes.userData ||
        errorCodes.reasons ||
        errorCodes.details ||
        errorCodes.about ||
        errorCodes.interests ||
        errorCodes.memberships ||
        errorCodes.creditCard ||
        errorCodes.billingAddress ||
        errorCodes.deletion ||
        errorCodes.verificationMessage ||
        errorCodes.termsAndConditions) && (
        <p className="sign-in__information">
          Something went wrong. Please try again later.
        </p>
      )
    )}
    <input className="application__button" type="submit" value="Join" />
  </form>
);

SignInView.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  formReference: PropTypes.object,
  sendApiRequest: PropTypes.func,
};

export default SignInView;
